import { getTestOverrides } from '@wix/cli-test-overrides';

const DEV_EDITOR_BASE_URL = 'https://wix.com/editor/';

export function getDevEditorBaseUrl(): string {
  return getTestOverrides().devEditorBaseUrl ?? DEV_EDITOR_BASE_URL;
}
